import {QuicksurveyStore} from 'client/common/types';

import {getUserQuery} from 'client/common/store/selectors/user';

import {isSurveyPreset} from 'client/common/store/reducers/question-bank/types';
import {SurveyPreset} from 'client/common/types/survey';

export function getPreset(state: QuicksurveyStore): SurveyPreset | undefined {
    return state.questionBank.preset;
}

export function getInitialPreset(state: QuicksurveyStore): SurveyPreset | undefined {
    const query = getUserQuery(state);

    if (isSurveyPreset(query.category)) {
        return query.category;
    }
}
